var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterBl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1680_7716)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 0H18.375C21.4816 0 24 2.5184 24 5.625V18.375C24 21.4816 21.4816 24 18.375 24H5.625C2.5184 24 0 21.4816 0 18.375V5.625C0 2.5184 2.5184 0 5.625 0ZM18.7202 9.01753C18.7202 8.86734 18.7202 8.71856 18.7099 8.56978C19.3878 8.07948 19.9729 7.47224 20.4375 6.77643C19.8059 7.05683 19.1357 7.24054 18.4493 7.3214C19.172 6.88872 19.7128 6.20827 19.9713 5.40665C19.2916 5.80981 18.5481 6.09405 17.7728 6.24712C16.4619 4.85343 14.2688 4.78621 12.8744 6.09703C12.4325 6.51245 12.1074 7.03661 11.9317 7.61709C11.7559 8.19758 11.7356 8.81403 11.8729 9.40481C10.4964 9.33602 9.14972 8.97843 7.92042 8.35528C6.69112 7.73212 5.60665 6.85734 4.73747 5.78775C3.81891 7.37006 4.28784 9.39384 5.80903 10.4106C5.25814 10.394 4.71927 10.2454 4.23778 9.97725V10.0211C4.23778 11.6692 5.39981 13.0883 7.01494 13.4147C6.50537 13.5539 5.97063 13.5743 5.45194 13.4743C5.67323 14.1622 6.10394 14.7637 6.68385 15.1947C7.26376 15.6258 7.96387 15.8649 8.68631 15.8785C7.46014 16.8417 5.94578 17.3647 4.38656 17.3634C4.11094 17.3628 3.83606 17.3464 3.5625 17.3135C5.14585 18.3294 6.98814 18.8682 8.86941 18.8655V18.8683C15.2376 18.8683 18.7202 13.5922 18.7202 9.01753Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1680_7716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBl);
export default __webpack_public_path__ + "static/media/twitterBl.914386880c2ad599b3d979ed1afd7c71.svg";
export { ForwardRef as ReactComponent };